import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../TextField/component';
import { Checkbox } from '../Forms/Checkbox';

export const ReduxFormField = ({
  input,
  label,
  type,
  meta: { touched, error },
}) => {
  if (type === 'checkbox') {
    return <Checkbox {...input} label={label} error={touched ? error : null} />;
  }

  return (
    <TextField
      {...input}
      label={label}
      type={type}
      error={touched ? error : null}
    />
  );
};
ReduxFormField.propTypes = {
  input: PropTypes.shape({
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onDragStart: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }).isRequired,
};
ReduxFormField.defaultProps = {
  label: '',
  placeholder: '',
};
